/* eslint-disable import/prefer-default-export */

import LocalStorageStore from './localStorageStore';

export const emojiStore = new LocalStorageStore('emoji');
